var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C9.95528 2.75 8.30997 4.40311 8.30997 6.44C8.30997 8.42302 9.85905 10.032 11.8149 10.1189C11.9335 10.1106 12.0588 10.1102 12.177 10.1188C14.1309 10.031 15.6809 8.42308 15.69 6.43847C15.6891 4.40339 14.0352 2.75 12 2.75ZM6.80997 6.44C6.80997 3.57689 9.12466 1.25 12 1.25C14.8642 1.25 17.19 3.57579 17.19 6.44L17.19 6.44313C17.1783 9.24352 14.9709 11.5259 12.1852 11.6196C12.1519 11.6207 12.1185 11.6196 12.0853 11.6163C12.0371 11.6115 11.9651 11.6108 11.8979 11.6169C11.8669 11.6197 11.8358 11.6206 11.8048 11.6196C9.01957 11.526 6.80997 9.24337 6.80997 6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1725 12.4375C14.1007 12.4375 16.067 12.9214 17.5865 13.9363C18.9524 14.8454 19.735 16.1198 19.735 17.4912C19.735 18.8626 18.9525 20.1393 17.5872 21.0532C16.063 22.0731 14.0941 22.56 12.165 22.56C10.2363 22.56 8.26788 22.0734 6.74379 21.0539C5.37768 20.1448 4.59497 18.8703 4.59497 17.4987C4.59497 16.1274 5.37741 14.8507 6.74276 13.9368L6.74551 13.9349C8.27394 12.9215 10.244 12.4375 12.1725 12.4375ZM7.5758 15.1842C6.52216 15.89 6.09497 16.7429 6.09497 17.4987C6.09497 18.2544 6.52198 19.1047 7.5754 19.8056L7.57704 19.8067C8.80283 20.6268 10.4641 21.06 12.165 21.06C13.8658 21.06 15.527 20.6269 16.7528 19.8068C17.8074 19.1007 18.235 18.2474 18.235 17.4912C18.235 16.7355 17.808 15.8853 16.7545 15.1844L16.7534 15.1837C15.533 14.3686 13.8743 13.9375 12.1725 13.9375C10.4715 13.9375 8.80724 14.3682 7.5758 15.1842Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8286bd0bd7569ab64aabcc8386e7bc86.svg";
export { ForwardRef as ReactComponent };